import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
// Imported for its side effect, and imported HERE rather than left to the
// component that uses it: `beforeinstallprompt` fires on Chromium's own
// schedule and must be caught — and preventDefault'd — before the first
// render, or the browser shows its own infobar and the app never gets the
// chance to ask properly. See install/prompt.ts.
import "./install/prompt";
import { installCues } from "./ui/feedback";
import { installRipple } from "./ui/ripple";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");

// Outside React on purpose: press feedback belongs to every button that will
// ever exist, including ones rendered by screens that have not been written yet.
installRipple();
// The audible half of the same idea, and selective where the ripple is not:
// only buttons that commit or advance make a sound. See ui/cues.ts.
installCues();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
